import { create } from 'zustand';

interface DeltaWithLeaveState {
  patFilterResponse: any[] | null;
  patFilterValues: Record<string, any> | null;
  remittedPatFilterResponse: any[] | null;
  remittedPatFilterValues: Record<string, any> | null;
}

interface DeltaWithoutLeaveState {
  allFilterRatsb: any[] | null;
  ratsbFilterValues: Record<string, any> | null;
  allFilterRatsbRemesed: any[] | null;
  ratsbRemesedFilterValues: Record<string, any> | null;
}

interface DeltaStore extends DeltaWithLeaveState, DeltaWithoutLeaveState {
  // Con baja
  setPatFilterResponse: (data: any[] | null) => void;
  setPatFilterValues: (values: Record<string, any> | null) => void;
  setRemittedPatFilterResponse: (data: any[] | null) => void;
  setRemittedPatFilterValues: (values: Record<string, any> | null) => void;
  clearWithLeave: () => void;

  // Sin baja
  setAllFilterRatsb: (data: any[] | null) => void;
  setRatsbFilterValues: (values: Record<string, any> | null) => void;
  setAllFilterRatsbRemesed: (data: any[] | null) => void;
  setRatsbRemesedFilterValues: (values: Record<string, any> | null) => void;
  clearWithoutLeave: () => void;
}

const useDeltaStore = create<DeltaStore>((set) => ({
  // Con baja - pendientes
  patFilterResponse: null,
  patFilterValues: null,
  // Con baja - remesados
  remittedPatFilterResponse: null,
  remittedPatFilterValues: null,

  setPatFilterResponse: (data) => set({ patFilterResponse: data }),
  setPatFilterValues: (values) => set({ patFilterValues: values }),
  setRemittedPatFilterResponse: (data) => set({ remittedPatFilterResponse: data }),
  setRemittedPatFilterValues: (values) => set({ remittedPatFilterValues: values }),
  clearWithLeave: () => set({
    patFilterResponse: null,
    patFilterValues: null,
    remittedPatFilterResponse: null,
    remittedPatFilterValues: null,
  }),

  // Sin baja - pendientes
  allFilterRatsb: null,
  ratsbFilterValues: null,
  // Sin baja - remesados
  allFilterRatsbRemesed: null,
  ratsbRemesedFilterValues: null,

  setAllFilterRatsb: (data) => set({ allFilterRatsb: data }),
  setRatsbFilterValues: (values) => set({ ratsbFilterValues: values }),
  setAllFilterRatsbRemesed: (data) => set({ allFilterRatsbRemesed: data }),
  setRatsbRemesedFilterValues: (values) => set({ ratsbRemesedFilterValues: values }),
  clearWithoutLeave: () => set({
    allFilterRatsb: null,
    ratsbFilterValues: null,
    allFilterRatsbRemesed: null,
    ratsbRemesedFilterValues: null,
  }),
}));

export default useDeltaStore;
